export default __webpack_public_path__ + "static/bg-right-swirl-e9dbc757a33b7af459ba2479d5a81741.png";